import React from "react";
import NavLite from "../../components/NavLite";
import Footer from "../../components/Footer";
import HeroImage from "../../assets/RuthPhoto/IMG_2822 2.JPG";
import HighSchoolImg from "../../assets/Blackwomen/BWI34.jpg";
import ValuesImg from "../../assets/bg/bg-new.jpg";
import Otherbg from "../../assets/bg/bg-new4.jpg";
import { Helmet } from "react-helmet";

const About = () => {

<Helmet>
  <title>About Our Female-Led Design Studio | Woaom Web Design</title>
  <meta
    name="description"
    content="Discover the story behind Woaom Web Design — a female-founded, women-owned studio creating intentional, scalable websites and digital platforms for ambitious entrepreneurs."
  />
  <meta
    name="keywords"
    content="about Woaom Web Design, female founder, women-owned design studio, women in web design, black women in tech, women entrepreneurs, female-led creative agency, intentional design studio, brand values, web design journey, meet the founder, empowering entrepreneurs, story behind the brand, founder mission, studio purpose, authentic branding, aligned design process, client-centered design, heart-led branding, mission-driven studio, creative agency for women, visionary design agency, women-led web design company, soulful design, brand philosophy, community-led growth, women in business, scalable design solutions, digital empowerment for women, inclusive design studio, aesthetic meets strategy"
  />
</Helmet>

  return (
    <section className="bg-white font-inter">
      {/* Hero Section */}
      <div
        className="relative px-4 text-center text-white pb-10"
        style={{
          backgroundImage: `url(${ValuesImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <div className="absolute inset-0 bg-black/80"></div>
        <div className="relative z-10">
          <NavLite />
          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10 items-center">
            <img
              src={HeroImage}
              alt="website template for coaches, feminine website template, React website template for service providers, sales page template, course website template, booking website template, Kajabi alternative, custom coded website, React Firebase landing page, website template for wellness brand"
              className="shadow-lg w-full max-w-sm mx-auto"
            />
            <div className="text-left">
              <h3 className="text-[#C6884A] font-handwriting text-xl mb-2 uppercase tracking-widest">
                Custom App & Website Design/Developer
              </h3>
              <h1 className="text-5xl  font-bold mb-6">
                Meet Ruth Zota
              </h1>
              <p className="text-lg mb-6 text-white/90">
                I specialize in building custom-coded web platforms and websites for women entrepreneurs leading in online coaching, wellness, and community. With 6+ years in UX and frontend dev, I help clients go beyond pretty brochure sites and into scalable, strategic digital spaces that convert.
              </p>
              <a
                href="/contact"
                className="inline-block px-6 py-3 bg-white text-[#2E2D2B] font-semibold rounded-full shadow hover:bg-gray-100 transition"
              >
                Let's Do This →
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Origin Story Section */}
      <div className="bg-[#F6F3F1] py-28 px-4 md:px-10">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <img src={HighSchoolImg} alt="waitlist landing page template, email list builder for coaches, launch waitlist template, build email list before launch, email capture website, prelaunch funnel template, flodesk landing page template, convertkit website template, freebie funnel for service business, list-building website template" className="rounded-lg shadow-md" />
          <div>
            <h2 className="text-4xl  mb-4 text-[#2E2D2B]">
              From Passion to Platform Innovation
            </h2>
            <p className="text-gray-700 text-lg">
              I began my career in the military, then moved into UX development at Johns Hopkins and major agencies. Today, I bring that technical rigor and creative vision to custom websites for coaches, SaaS founders, and community builders ready to scale. Woaom Web Design is my vehicle for helping women lead boldly in digital spaces.
            </p>
          </div>
        </div>
      </div>

      {/* Values Section */}
      <div
        className="relative bg-black text-white py-24 text-center"
        style={{ backgroundImage: `url(${Otherbg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-4">
          <h2 className="text-4xl  font-bold mb-4">
            Design Backed by Strategy, Built for Impact
          </h2>
          <p className="text-lg">
            I believe in building platforms that support your vision long after launch. With empathy, clarity, and technical skill, I design experiences that drive transformation—for your users and your business.
          </p>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-white py-20 px-4 text-center">
        <h2 className="text-4xl  mb-4 text-[#2E2D2B]">
          Let’s Launch a Platform That Works as Hard as You Do
        </h2>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-6">
          Whether you're leading a coaching brand, wellness business, or growing a digital community — I’ll help you build the backend systems and frontend experience that scale your reach and revenue.
        </p>
        <a
          href="/contact"
          className="inline-block px-8 py-4 bg-[#CFF098] text-[#2E2D2B] font-semibold rounded-full hover:bg-[#b0d884] transition"
        >
          Start Your Project →
        </a>
      </div>

      <Footer />
    </section>
  );
};

export default About;
